module.exports = __webpack_public_path__ + "img/qilin-stage5.6f8e309d.png";